import {Form, Formik} from 'formik';
import {Modal} from 'react-bootstrap';

import './filter.scss';
import {

  roleTypesEnum,
  userStatusEnum,

} from '../../../../utils/constants';
import SingleSelectDropdown from '../../../../components/form/singleSelectDropdown/singleSelectDropdown';
import { assets } from '../../../../utils/assetsSrc';
import Button from '../../../../components/form/button/button';

export default function Filter({
  label,
  show,
  setShow,
  handleFilterChange,
  config,
}) {
  const initialValues = {
    statusType: userStatusEnum.find(item => item.id === config.status)?? '',
    roleType: roleTypesEnum.find(item => item.id === config.role) ??'' ,
  };




  const handleSubmit = vals => {
    const payload = {

      status: vals.statusType?.id,
      role: vals.roleType?.id,
    };
    handleFilterChange(payload);
  };

  return (
    <Modal
      show={show}
      onHide={() => setShow(false)}
      aria-labelledby="filter"
      centered
      className="filter">
      <Modal.Body className="p-5 px-5 text-center">
        <div className="header">
          <p className="label mt-3 mb-4">{label}</p>
          <img onClick={() => setShow(false)} src={assets.closeIcon} />
        </div>
        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          enableReinitialize>
          {({formik, values, setFieldValue, isSubmitting, isValid, errors}) => (
            <Form>
              <div className="user-multiselect">
                <SingleSelectDropdown
                  label={'Select Status'}
                  listItems={userStatusEnum}
                  name="statusType"
                  value={values['statusType']}
                  handleSelectedUsersChange={val => {
                    setFieldValue('statusType', val);
                  }}
                />
              </div>
              <div className="user-multiselect">
                <SingleSelectDropdown
                  label={'Select Role'}
                  listItems={roleTypesEnum}
                  name="roleType"
                  value={values['roleType']}
                  handleSelectedUsersChange={val => {
                    setFieldValue('roleType', val);
                  }}
                />
              </div>
              <div className="action-buttons">
                <Button
                  type="submit"
                  clickHandler={() => {
                    setFieldValue('statusType', '');
                    setFieldValue('roleType', '');
                  }}
                  variant="secondary-button">
                  Reset
                </Button>

                <Button type="submit" variant="submit-button">
                  Apply
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
}
